import { GqlPlannerV2MapElementPointType } from "~/__generated__";

import { PlannerV2TravelGroupGetTimelineQuery } from "../../queries.generated";
import { LocationMetadata } from "./shiftPickupMetadata";

type MapPoint = NonNullable<PlannerV2TravelGroupGetTimelineQuery["mapElements"]>["points"][number];

interface CategorizedMapPoints {
    pickupPoints: MapPoint[];
    fieldworkerHomeMarkers: MapPoint[];
}

export function categorizeMapPoints(
    points: MapPoint[] | undefined,
    locationMetadataByShiftId: Map<string, LocationMetadata>,
): CategorizedMapPoints {
    const pickupPoints: MapPoint[] = [];
    const fieldworkerHomeMarkers: MapPoint[] = [];

    if (!points) return { pickupPoints, fieldworkerHomeMarkers };

    points.forEach(point => {
        const someShiftsHaveSecondaryTravel = point.plannerShiftTravels.some(
            shiftTravel => locationMetadataByShiftId.get(shiftTravel.plannerShiftId)?.shiftHasSecondaryTravel === true,
        );
        if (point.type === GqlPlannerV2MapElementPointType.FieldworkerStartExit && someShiftsHaveSecondaryTravel) {
            fieldworkerHomeMarkers.push(point);
        } else {
            pickupPoints.push(point);
        }
    });

    return { pickupPoints, fieldworkerHomeMarkers };
}
